export default __webpack_public_path__ + "static/finance-fraud-prevention-img-2-dbfd67adb58cad8ae43b68dd2c10b1ec.svg";